import { useEffect, useState } from "react"
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";

import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentRow, MyModalContentSelectInput, MyModalContentSelectInputOption, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles"; import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export default function VvUpdate({ rowEntry, instance, evus, arten, zvs, reloadData }) {
    const [showModal, setShowModal] = useState(false);
    const [upAvailable, setUpAvailable] = useState(false);
    const [myComment, setMyComment] = useState('');

    const [vvUpdate, setVvUpdate] = useState(new MonitorApi.UpdateVerkehrsvertrag());
    const [checkZvs, setCheckZvs] = useState({});
    const [dropdowns] = useState({
        "evus": evus,
        "arten": arten,
        "zvs": zvs
    });

    useEffect(() => {
        zvs.map(zv => setCheckZvs(pre => ({ ...pre, [zv.id]: false })));
        rowEntry.original.korr_zvs.map(zv => setCheckZvs(pre => ({ ...pre, [zv.id]: true })))
    }, [rowEntry, zvs])

    useEffect(() => {
        setVvUpdate(pre => ({ ...pre, 'korr_zvs': Object.keys(checkZvs).filter(it => checkZvs[it]) }));
    }, [checkZvs]);

    const formatDate = ddmmyyyy => {
        if (ddmmyyyy === null) {
            return null;
        }

        const arr = ddmmyyyy.split('.');
        var date = '';
        date = date.concat(arr[2], '-');
        if (arr[1].length < 2) {
            date = date.concat('0', arr[1], '-');
        } else {
            date = date.concat(arr[1], '-');
        }
        if (arr[0].length < 2) {
            date = date.concat('0', arr[0]);
        } else {
            date = date.concat(arr[0]);
        }
        return date
    }

    const [inputs, setInputs] = useState({});

    const [classes, setClasses] = useState({});

    const resetClasses = () => {
        setClasses({
            vertrag: "unchanged",
            id_art: "unchanged",
            id_evu: "unchanged",
            beginn: "unchanged",
            ende: "unchanged",
            kommentar: "unchanged"
        });
    }

    const openModal = event => {
        setInputs({
            vertrag: rowEntry.original.vertrag,
            id_art: rowEntry.original.id_art,
            id_evu: rowEntry.original.id_evu,
            beginn: formatDate(rowEntry.original.beginn),
            ende: rowEntry.original.ende ? formatDate(rowEntry.original.ende) : undefined,
            // kommentar: rowEntry.kommentar
        });
        setMyComment(rowEntry.original.kommentar);
        setUpAvailable(false);
        resetClasses();
        setVvUpdate(pre => ({ ...pre, "vvId": rowEntry.original.id }));
        setShowModal(true);
    }

    const resetZvUpdate = () => {
        Object.keys(checkZvs).forEach(
            it => setCheckZvs(pre => ({ ...pre, [it]: false }))
        );
        rowEntry.original.korr_zvs.map(
            zv => setCheckZvs(pre => ({ ...pre, [zv.id]: true }))
        );
    }

    const closeModal = () => {
        setShowModal(false);
        setVvUpdate({});
        resetZvUpdate();
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const changingUpdate = event => {
        setClasses(pre => ({ ...pre, [event.target.id]: "changed" }));
        setVvUpdate(pre => ({ ...pre, [event.target.id]: event.target.value }));

        if (event.target.id === 'kommentar') {
            setMyComment(event.target.value);
        }
        setUpAvailable(true);
    }

    const updateZvs = event => {
        console.log(event.target.value, event.target.checked)
        setCheckZvs(pre => ({ ...pre, [event.target.value]: event.target.checked }));
        // setClasses(pre => ({ ...pre, [event.target.id]: "changed" }));
        setUpAvailable(true);
    }

    const saveChanges = event => {
        event.preventDefault();
        console.log(vvUpdate)
        instance.updateVerkehrsvertragPatch(vvUpdate, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                alert("Änderungen gespeichert");
                closeModal();
                reloadData();
            }
        })
    }

    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saveChanges}>
                    <MyModalContentRow>
                        <label>Verkehrsvertrag:
                            <MyModalContentTextInput id="vertrag" className={classes.vertrag}
                                onChange={changingUpdate}
                                value={vvUpdate.vertrag ? vvUpdate.vertrag : inputs.vertrag}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Verkehrsvertragsart:
                            <MyModalContentSelectInput id="id_art" className={classes.id_art}
                                onChange={changingUpdate} value={vvUpdate.id_art ? vvUpdate.id_art : inputs.id_art} >
                                {dropdowns.arten.map(art =>
                                    <MyModalContentSelectInputOption value={art.id} key={art.id} className={art.id === inputs.id_art ? "origin" : ""}>
                                        {art.vvart}
                                    </MyModalContentSelectInputOption>
                                )}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Eisenbahnverkehrsunternehmen:
                            <MyModalContentSelectInput onChange={changingUpdate} id="id_evu" className={classes.id_evu}
                                value={vvUpdate.id_evu ? vvUpdate.id_evu : inputs.id_evu}>
                                {dropdowns.evus.map(evu =>
                                    <MyModalContentSelectInputOption value={evu.id} key={evu.id} className={evu.id === inputs.id_evu ? "origin" : ""}>
                                        {evu.evu}
                                    </MyModalContentSelectInputOption>
                                )}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <label>zugehörige Zweckverbände:
                        <ul type="none" className="zv-list">
                            {zvs.map(zv => <li key={zv.id}>
                                <label>
                                    <input style={{ accentColor: '#56c3be' }}
                                        type="checkbox" value={zv.id} checked={checkZvs[zv.id]} onChange={updateZvs} />
                                    {zv.kurz}
                                </label>
                            </li>)}
                        </ul>
                    </label>
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn ({inputs.beginn}):
                            <MyModalContentDateInput id="beginn" className={classes.beginn}
                                onChange={changingUpdate} value={vvUpdate.beginn ? vvUpdate.beginn : inputs.beginn}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende {inputs.ende ? `(${inputs.ende})` : "(optional)"}:
                            <MyModalContentDateInput id="ende" className={classes.ende}
                                min={vvUpdate.gueltig_von}
                                onChange={changingUpdate} value={vvUpdate.ende ? vvUpdate.ende : inputs.ende}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput id="kommentar" className={classes.kommentar}
                                onChange={changingUpdate} value={myComment}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>
    )
}